export const USER_HAS_NO_DASHBOARDS = 'USER_HAS_NO_DASHBOARDS';
export default {};
